// extracted by mini-css-extract-plugin
export var container = "_8i-0";